import React from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import LayOut from './Components/LayOut/LayOut'
import Products from './Components/ProductsComponents/Products/Products'
import Login from './Components/Login/Login'
import Register from './Components/Register/Register'
import NotFound from './Components/NotFound/NotFound'
import { AuthProvider } from './Context/Authentication'
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute'

import { QueryClient , QueryClientProvider } from 'react-query' 

import Home from './Components/Home/Home'

import toast, { Toaster } from 'react-hot-toast';
import Addproduct from './Components/ProductsComponents/AddProduct/Addproduct'
import UpdateProduct from './Components/ProductsComponents/UpdateProduct/UpdateProduct'



import Categories from './Components/CategoriesComponents/Categories/Categories'
import AddCategory from './Components/CategoriesComponents/AddCategory/AddCategory'
import UpdateCategory from './Components/CategoriesComponents/UpdateCategory/UpdateCategory'
import CategoryProducts from './Components/CategoriesComponents/CategoryProduct/CategoryProducts'


import BrandProducts from './Components/BrandsComponents/BrandProduct/BrandProducts'
import UpdateBrand from './Components/BrandsComponents/UpdateBrand/UpdateBrand'
import AddBrand from './Components/BrandsComponents/AddBrand/AddBrand'
import Brands from './Components/BrandsComponents/Brands/Brands'



import OpeningBalanceForm from './Components/OpeningBalanceComponents/CreateOpenBalance/OpeningBalanceForm'
import AllSuppliers from './Components/SupplierComponents/AllSuppliers'
import AddSupplier from './Components/SupplierComponents/AddSupplier'
import UpdateSupplier from './Components/SupplierComponents/UpdateSupplier'
import PurchaseForm from './Components/PurchaseComponents/PurchaseForm'
import PurchaseSummary from './Components/PurchaseComponents/PurchaseSummary'
import PurchaseDetails from './Components/PurchaseComponents/PurchaseDetails'
import PurchaseSupplierSummary from './Components/PurchaseComponents/PurchaseSupplierSummary'
import AddPayment from './Components/PurchaseComponents/AddPayment'
import CreateCustomer from './Components/CustomerComponents/CreateCustomer'
import AllCustomers from './Components/CustomerComponents/AllCustomers'
import UpdateCustomer from './Components/CustomerComponents/UpdateCustomer'
import SaleForm from './Components/SaleComponents/CreateSale'
import SalesSummary from './Components/SaleComponents/SalesSummary'
import SaleDetails from './Components/SaleComponents/SaleDetails'
import AddPaymentSale from './Components/SaleComponents/AddPaymentSale'
import SaleCustomerSummary from './Components/SaleComponents/SaleCustomerSummary'
import NetProfitSummary from './Components/NetProfitSummary'
import UpdatePurchase from './Components/PurchaseComponents/UpdatePurchase'
import UpdateSale from './Components/SaleComponents/UpdateSale'
import AllNoticfications from './Components/NotificationComponents/AllNoticfications'
import TopProfits from './Components/AnalysisComponents/TopProfits'
import TopSelling from './Components/AnalysisComponents/TopSelling'
import TopSupplier from './Components/AnalysisComponents/TopSupplier'
import TopCustomers from './Components/AnalysisComponents/TopCustomers'
import AllAdmins from './Components/AdminComponets/AllAdmins'
import CreateNewExpense from './Components/ExpensecComponents/CreateNewExpense'
import AllExpense from './Components/ExpensecComponents/AllExpense'
import UpdateExpense from './Components/ExpensecComponents/UpdateExpense'
import DashboardCounts from './Components/Dashborad/DashboardCounts'
import Inventoryvalue from './Components/AnalysisComponents/Inventoryvalue'
import CreateIncome from './Components/IncomesComponents/CreateIncome'
import Incomes from './Components/IncomesComponents/Incomes'
import CreateSupplierOpenBalance from './Components/OpeningBalanceComponents/SupplierOpenSystemForm/CreateSupplierOpenBalance'
import SupplierBalanceOpenSummary from './Components/OpeningBalanceComponents/SupplierOpenSystemForm/SupplierBalanceOpenSummary'
import CreateCustomerOpenBalance from './Components/OpeningBalanceComponents/CustomerOpenSystem/CreateCustomerOpenBalance'
import CustomersBalanceSummary from './Components/OpeningBalanceComponents/CustomerOpenSystem/CustomersBalanceSummry'
import SupplierOpenSystemAddPayment from './Components/OpeningBalanceComponents/SupplierOpenSystemForm/SupplierOpenSystemAddPayment'
import SupplierOpenBalanceDetails from './Components/OpeningBalanceComponents/SupplierOpenSystemForm/SupplierOpenBalanceDetails'
import CustomerOpenSystemDetails from './Components/OpeningBalanceComponents/CustomerOpenSystem/CustomerOpenSystemDetails'
import CustomerOpenBalancePayment from './Components/OpeningBalanceComponents/CustomerOpenSystem/CustomerOpenBalancePayment'
import SupplierFullFinancial from './Components/SupplierComponents/SupplierFullFinancial'
import CustomerFullFinancial from './Components/CustomerComponents/CustomerFullFinancial'
import BulkPaymentForm from './Components/SaleComponents/BulkPaymentForm'


// from gitlab


const MyRouter = createBrowserRouter(  [


{
  path : "/" , element : <LayOut/> , children : [

    {index : true , element :<ProtectedRoute> <Home /> </ProtectedRoute>  },
    {path :"home" , element :<ProtectedRoute>  <Home /> </ProtectedRoute>} ,

    {path :"Dashboard" , element :<ProtectedRoute>  <DashboardCounts /> </ProtectedRoute>} ,
    


    {path :"login" , element : <Login/>} ,
    {path :"register" , element : <ProtectedRoute>  <Register/> </ProtectedRoute> } ,
    {path :"alladmin" , element : <ProtectedRoute>  <AllAdmins/> </ProtectedRoute> } ,


    {path :"products" , element :<ProtectedRoute>  <Products/> </ProtectedRoute>} ,
    {path :"/add-product" , element : <ProtectedRoute><Addproduct/> </ProtectedRoute>} ,
    { path: "/update-product/:productId", element: <ProtectedRoute><UpdateProduct/></ProtectedRoute> },
    

    {path :"categories" , element : <ProtectedRoute><Categories/> </ProtectedRoute>} ,
    {path :"/add-category" , element : <ProtectedRoute><AddCategory/> </ProtectedRoute>} ,
    { path: "/update-category/:CategoryId", element: <ProtectedRoute><UpdateCategory/></ProtectedRoute> },
    {path :"categories/:id" , element : <ProtectedRoute><CategoryProducts/> </ProtectedRoute>} ,
  
    {path :"brands" , element : <ProtectedRoute> <Brands/> </ProtectedRoute>} ,
    {path :"/add-brand" , element : <ProtectedRoute><AddBrand/> </ProtectedRoute>} ,
    {path: "/update-brand/:BrandId", element: <ProtectedRoute><UpdateBrand/></ProtectedRoute> },
    {path :"Brands/:id" , element : <ProtectedRoute><BrandProducts/> </ProtectedRoute>} ,


    {path :"open-balance" , element : <ProtectedRoute><OpeningBalanceForm/> </ProtectedRoute>} ,
    
    {path :"suppliers" , element : <ProtectedRoute> <AllSuppliers/> </ProtectedRoute>} ,
    {path :"supplierfinancial" , element : <ProtectedRoute> <SupplierFullFinancial/> </ProtectedRoute>} ,
    {path :"add-supplier" , element : <ProtectedRoute> <AddSupplier/> </ProtectedRoute>} ,
    {path :"update-supplier/:id" , element : <ProtectedRoute> <UpdateSupplier/> </ProtectedRoute>} ,
    
    
    {path :"create-purchase" , element : <ProtectedRoute><PurchaseForm/> </ProtectedRoute>} ,
    {path :"purchases" , element : <ProtectedRoute><PurchaseSummary/> </ProtectedRoute>} ,
    {path :"purchases/:id" , element : <ProtectedRoute><PurchaseDetails/> </ProtectedRoute>} ,
    
    {path :"/suppliers/:id/purchases" , element : <ProtectedRoute><PurchaseSupplierSummary/> </ProtectedRoute>} ,
    
    {path :"/purchases/:id/update" , element : <ProtectedRoute><UpdatePurchase/> </ProtectedRoute>} ,
    
    

    
    {path :"customers" , element : <ProtectedRoute> <AllCustomers/> </ProtectedRoute>} ,
    {path :"add-customer" , element : <ProtectedRoute> <CreateCustomer/> </ProtectedRoute>} ,
    {path :"update-customer/:id" , element : <ProtectedRoute> <UpdateCustomer/> </ProtectedRoute>} ,
    {path :"customerfinancial" , element : <ProtectedRoute> <CustomerFullFinancial/> </ProtectedRoute>} ,
    

    {path :"create-sale" , element : <ProtectedRoute><SaleForm/> </ProtectedRoute>} ,
    {path :"sales" , element : <ProtectedRoute><SalesSummary/> </ProtectedRoute>} ,
    {path :"sales/:id" , element : <ProtectedRoute><SaleDetails/> </ProtectedRoute>} ,
    {path :"/customers/:id/sales" , element : <ProtectedRoute><SaleCustomerSummary/> </ProtectedRoute>} ,
    {path :"create-bulk-sale" , element : <ProtectedRoute><BulkPaymentForm/> </ProtectedRoute>} ,




    {path :"/sales/:id/update" , element : <ProtectedRoute><UpdateSale/> </ProtectedRoute>} ,
    
    {path :"/purchases/:id/add-payment" , element : <ProtectedRoute><AddPayment/> </ProtectedRoute>} ,
    {path :"/sales/:id/add-payment-sale" , element : <ProtectedRoute><AddPaymentSale/> </ProtectedRoute>} ,
    
    


{path :"/expense" , element : <ProtectedRoute><AllExpense/> </ProtectedRoute>} ,
{path :"/create-expense" , element : <ProtectedRoute><CreateNewExpense/> </ProtectedRoute>} ,
{path :"/expenses/:id/update" , element : <ProtectedRoute><UpdateExpense/> </ProtectedRoute>} ,


{path :"/income" , element : <ProtectedRoute><Incomes/> </ProtectedRoute>} ,
{path :"/create-income" , element : <ProtectedRoute><CreateIncome/> </ProtectedRoute>} ,


{path :"/open-balance-suppliers" , element : <ProtectedRoute><CreateSupplierOpenBalance/> </ProtectedRoute>} ,
{path :"/balance-suppliers" , element : <ProtectedRoute><SupplierBalanceOpenSummary/> </ProtectedRoute>} ,
{path :"/supplier-opening-balance/:id/add-payment" , element : <ProtectedRoute><SupplierOpenSystemAddPayment/> </ProtectedRoute>} ,
{path :"/supplier-opening-balance/:id" , element : <ProtectedRoute><SupplierOpenBalanceDetails/> </ProtectedRoute>} ,



{path :"/open-balance-customers" , element : <ProtectedRoute><CreateCustomerOpenBalance/> </ProtectedRoute>} ,
{path :"/balance-customers" , element : <ProtectedRoute><CustomersBalanceSummary/> </ProtectedRoute>} ,
{path :"/customer-opening-balance/:id" , element : <ProtectedRoute><CustomerOpenSystemDetails/> </ProtectedRoute>} ,
{path :"/customer-opening-balance/:id/add-payment" , element : <ProtectedRoute><CustomerOpenBalancePayment/> </ProtectedRoute>} ,




    
    {path :"noticifcations" , element : <ProtectedRoute> <AllNoticfications/> </ProtectedRoute>} ,
    

    {path :"net" , element : <ProtectedRoute> <NetProfitSummary/> </ProtectedRoute>} ,
    {path :"topprofits" , element : <ProtectedRoute> <TopProfits/> </ProtectedRoute>} ,
    {path :"topselling" , element : <ProtectedRoute> <TopSelling/> </ProtectedRoute>} ,
    {path :"topsupplier" , element : <ProtectedRoute> <TopSupplier/> </ProtectedRoute>} ,
    {path :"topcustomer" , element : <ProtectedRoute> <TopCustomers/> </ProtectedRoute>} ,
    {path :"inventoryvalue" , element : <ProtectedRoute> <Inventoryvalue/> </ProtectedRoute>} ,

    
    {path :"*" , element : <NotFound/>} ,
  ]
}
])




export default function App() {

  let clientQuery = new QueryClient();
  
  return (
    <>

    <QueryClientProvider client={clientQuery}>
    <AuthProvider>
    <RouterProvider    router={MyRouter} />
    </AuthProvider>
    <Toaster />
    </QueryClientProvider>
    </>
  )
}
